module.exports = __webpack_public_path__ + "static/12-5-a97955e302d3da2241c1436b897a4bbf.jpg";